import { m, LazyMotion, domAnimation } from 'framer-motion';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const itemHeadingPlusVariants = {
  from: {
    rotate: 0,
  },
  to: {
    rotate: 90,
    transition: { duration: 0.3 },
  },
  exit: {
    rotate: 0,
    transition: { duration: 0.3 },
  },
};

const itemContentVariants = {
  from: {
    height: 0,
  },
  to: {
    height: 'auto',
    transition: { duration: 0.3 },
  },
  exit: {
    height: 0,
    transition: { duration: 0.3 },
  },
};

const FAQ = ({ title, description, items }) => {
  const [activeItemIndexes, setActiveItemIndexes] = useState({});

  return (
    <section className="safe-paddings scroll-mt-20" id="faq">
      <div className="container-sm">
        <h2 className="text-center text-5xl font-bold leading-denser">{title}</h2>
        {description && <p className="mt-3 text-center">{description}</p>}
        <ul className="mt-11">
          <LazyMotion features={domAnimation}>
            {items.map(({ title, description }, index) => {
              const isActive = activeItemIndexes[index];

              const handleHeaderClick = () => {
                setActiveItemIndexes((previousActiveItemIndexes) => ({
                  ...previousActiveItemIndexes,
                  [index]: !isActive,
                }));
              };

              return (
                <m.li
                  className="overflow-hidden border-b border-b-gray-4 py-5 last:border-b-0"
                  key={index}
                  initial="from"
                  animate={isActive ? 'to' : 'exit'}
                >
                  <div
                    className="flex justify-between space-x-2.5 outline-none transition-colors duration-200 hover:text-primary-2"
                    role="button"
                    tabIndex="0"
                    onClick={handleHeaderClick}
                    onKeyDown={handleHeaderClick}
                  >
                    <h3 className="text-xl font-medium">{title}</h3>
                    <span className="relative mt-3.5 h-0.5 w-3.5 flex-shrink-0 bg-black md:hidden">
                      <m.span
                        className="absolute -top-1.5 left-1.5 h-3.5 w-0.5 bg-black"
                        variants={itemHeadingPlusVariants}
                      />
                    </span>
                  </div>
                  <m.div className="max-w-[936px] overflow-hidden" variants={itemContentVariants}>
                    <div
                      className="with-link-primary-2 mt-2.5 space-y-2.5"
                      dangerouslySetInnerHTML={{ __html: description }}
                    />
                  </m.div>
                </m.li>
              );
            })}
          </LazyMotion>
        </ul>
      </div>
    </section>
  );
};

FAQ.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
};

FAQ.defaultProps = {
  description: null,
};

export default FAQ;
